export interface TvShow {
  id: number;
  title: string;
  enTitle: string;
  year: number;
  rating: number;
  genres: string[];
  region: string;
  director: string;
  cast: string[];
  episodes: number;
  status: '连载中' | '已完结';
  poster: string;
  backdrop: string;
  synopsis: string;
  type: 'tv';
  popularity: number;
  releaseDate: string;
  featured?: boolean;
}

export const tvShows: TvShow[] = [
  {
    id: 2001,
    title: '长安夜行',
    enTitle: 'Night Walk in Chang\u2019an',
    year: 2024,
    rating: 9.0,
    genres: ['古装', '悬疑'],
    region: '大陆',
    director: '崔明烛',
    cast: ['谢临渊', '沈绾绾', '裴子期'],
    episodes: 36,
    status: '连载中',
    poster: 'https://readdy.ai/api/search-image?query=A%20cloaked%20figure%20with%20a%20lantern%20walking%20through%20ancient%20Chinese%20city%20streets%20at%20night%2C%20historical%20mystery%20drama%20poster%2C%20deep%20navy%20night%20tones%20with%20warm%20orange%20lantern%20glow%2C%20dramatic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20warm%20orange%20lanterns%20and%20deep%20navy%20sky%2C%20historical%20mystery%20wide%20shot%2C%20atmospheric%20cinematic%20key%20art%2C%20high%20detail&width=1600&height=900&seq=tv-backdrop-01&orientation=landscape',
    synopsis: '盛唐长安，一桩发生在宵禁后的离奇命案，惊动了整个大理寺。年轻推官与神秘画师联手追查，越查越发现，真相背后牵扯的是足以动摇整座城池的秘密。',
    type: 'tv',
    popularity: 9920,
    releaseDate: '2024-08-01',
    featured: true,
  },
  {
    id: 2002,
    title: '都市浮生记',
    enTitle: 'City Dwellers',
    year: 2024,
    rating: 8.5,
    genres: ['都市', '情感'],
    region: '大陆',
    director: '温言',
    cast: ['顾屿', '苏晓棠', '郭子铭'],
    episodes: 40,
    status: '已完结',
    poster: 'https://readdy.ai/api/search-image?query=Young%20professionals%20silhouetted%20against%20a%20glowing%20city%20skyline%20at%20dusk%2C%20modern%20urban%20drama%20poster%2C%20deep%20navy%20tones%20with%20warm%20orange%20city%20lights%2C%20refined%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20modern%20city%20skyline%20at%20dusk%20with%20warm%20orange%20office%20windows%20and%20deep%20navy%20sky%2C%20urban%20drama%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-02&orientation=landscape',
    synopsis: '三位在同一栋写字楼里打拼的年轻人，在升职、爱情与家庭之间反复拉扯。他们努力想在城市里扎根，却发现真正难的不是留下来，而是别忘了当初为什么来。',
    type: 'tv',
    popularity: 8450,
    releaseDate: '2024-04-18',
  },
  {
    id: 2003,
    title: '风起江湖',
    enTitle: 'Wind Over the Rivers',
    year: 2023,
    rating: 8.7,
    genres: ['武侠', '古装'],
    region: '大陆',
    director: '徐长空',
    cast: ['萧北风', '柳如烟', '陆青衫'],
    episodes: 45,
    status: '已完结',
    poster: 'https://readdy.ai/api/search-image?query=Two%20swordsmen%20facing%20off%20on%20a%20misty%20mountain%20bridge%20at%20dusk%2C%20wuxia%20drama%20poster%2C%20deep%20navy%20mist%20with%20warm%20amber%20sunset%20accent%2C%20dramatic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20misty%20mountain%20bridge%20at%20dusk%20with%20distant%20swordsman%20silhouettes%2C%20wuxia%20epic%20wide%20shot%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20atmospheric%20cinematic%20key%20art%2C%20high%20detail&width=1600&height=900&seq=tv-backdrop-03&orientation=landscape',
    synopsis: '一场武林大会，让销声匿迹多年的魔教重出江湖。出身名门的少侠与来历不明的少女被迫同行，一路揭开父辈往事，也渐渐明白：所谓正邪，从来不是分得那么清楚的。',
    type: 'tv',
    popularity: 7980,
    releaseDate: '2023-09-12',
  },
  {
    id: 2004,
    title: '时空迷航',
    enTitle: 'Adrift in Time',
    year: 2024,
    rating: 8.9,
    genres: ['科幻', '悬疑'],
    region: '美国',
    director: 'Marcus Cole',
    cast: ['艾登·福斯特', '诺拉·凯恩', '杰克·雷诺'],
    episodes: 24,
    status: '连载中',
    poster: 'https://readdy.ai/api/search-image?query=A%20spaceship%20crew%20silhouetted%20before%20a%20glowing%20orange%20time%20rift%2C%20sci-fi%20mystery%20drama%20poster%2C%20deep%20navy%20void%20background%2C%20dramatic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20glowing%20orange%20time%20rift%20in%20deep%20navy%20space%20with%20a%20distant%20spaceship%2C%20sci-fi%20mystery%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-04&orientation=landscape',
    synopsis: '一艘执行深空任务的飞船意外跌入时间裂隙，船员们发现每次跳跃都会带回一段不属于自己的记忆。当过去与未来开始重叠，他们必须找出到底是谁在操纵这一切。',
    type: 'tv',
    popularity: 9120,
    releaseDate: '2024-06-06',
    featured: true,
  },
  {
    id: 2005,
    title: '医者仁心',
    enTitle: 'Heart of a Healer',
    year: 2023,
    rating: 8.6,
    genres: ['职场', '医疗'],
    region: '大陆',
    director: '林清和',
    cast: ['方志远', '许安然', '陈嘉树'],
    episodes: 38,
    status: '已完结',
    poster: 'https://readdy.ai/api/search-image?query=A%20surgeon%20in%20scrubs%20standing%20in%20a%20hospital%20corridor%20under%20warm%20orange%20light%2C%20medical%20drama%20poster%2C%20deep%20navy%20shadows%2C%20clean%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20hospital%20corridor%20at%20night%20with%20warm%20orange%20lighting%20and%20deep%20navy%20shadows%2C%20medical%20drama%20wide%20shot%2C%20clean%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-05&orientation=landscape',
    synopsis: '急诊科永远没有平静的夜晚。一位坚持原则的主任医师，带着一群个性鲜明的年轻医生，在生死边缘一次次做出抉择，也在一次次告别中，重新理解了「医者」二字的重量。',
    type: 'tv',
    popularity: 7680,
    releaseDate: '2023-07-20',
  },
  {
    id: 2006,
    title: '山海秘闻录',
    enTitle: 'Chronicles of Mountains and Seas',
    year: 2024,
    rating: 8.4,
    genres: ['奇幻', '冒险'],
    region: '大陆',
    director: '崔明烛',
    cast: ['裴子期', '白芷', '玄烬'],
    episodes: 32,
    status: '连载中',
    poster: 'https://readdy.ai/api/search-image?query=A%20mythical%20beast%20emerging%20from%20misty%20mountains%20behind%20a%20young%20traveler%2C%20fantasy%20adventure%20drama%20poster%2C%20deep%20navy%20mist%20with%20warm%20orange%20magic%20glow%2C%20epic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20misty%20mountains%20with%20a%20glowing%20orange%20mythical%20creature%20silhouette%20and%20deep%20navy%20sky%2C%20fantasy%20epic%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-06&orientation=landscape',
    synopsis: '传说中记载着上古神兽的古卷意外现世，一个普通少年被卷入人与灵之间的千年纷争。他必须走遍山海秘境，收集失落的封印，才能阻止一场席卷人间的浩劫。',
    type: 'tv',
    popularity: 8360,
    releaseDate: '2024-05-09',
  },
  {
    id: 2007,
    title: '家宴',
    enTitle: 'The Family Table',
    year: 2022,
    rating: 8.8,
    genres: ['家庭', '伦理'],
    region: '大陆',
    director: '沈砚秋',
    cast: ['王宝娟', '周正阳', '李蕙兰'],
    episodes: 34,
    status: '已完结',
    poster: 'https://readdy.ai/api/search-image?query=A%20warm%20family%20dinner%20table%20laden%20with%20home%20cooked%20dishes%20under%20orange%20light%2C%20family%20drama%20poster%2C%20deep%20navy%20evening%20shadows%2C%20intimate%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20cozy%20family%20dining%20room%20with%20warm%20orange%20lamp%20glow%20and%20deep%20navy%20evening%20shadows%2C%20intimate%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-07&orientation=landscape',
    synopsis: '一张摆了三十年的饭桌，见证了一个普通家庭的聚散离合。母亲用一桌桌家常菜维系着渐行渐远的儿女，直到有一天，她终于说出了那个藏了大半辈子的秘密。',
    type: 'tv',
    popularity: 7320,
    releaseDate: '2022-11-15',
  },
  {
    id: 2008,
    title: '刑警日记',
    enTitle: 'Detective Diaries',
    year: 2023,
    rating: 8.5,
    genres: ['刑侦', '悬疑'],
    region: '大陆',
    director: '关启铭',
    cast: ['程一鸣', '黎婉清', '周景深'],
    episodes: 40,
    status: '已完结',
    poster: 'https://readdy.ai/api/search-image?query=A%20detective%20studying%20case%20files%20under%20a%20desk%20lamp%20in%20a%20night%20office%2C%20crime%20drama%20poster%2C%20deep%20navy%20shadows%20with%20warm%20orange%20lamp%20glow%2C%20dramatic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20night%20police%20office%20full%20of%20case%20boards%20with%20warm%20orange%20lamp%20glow%20and%20deep%20navy%20shadows%2C%20crime%20drama%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-08&orientation=landscape',
    synopsis: '一个刑警队的日常，被写进了一本本厚厚的日记。从鸡毛蒜皮的邻里纠纷到牵动全城的重大案件，他们用最笨的办法——坚持，一点一点把真相从沉默里挖出来。',
    type: 'tv',
    popularity: 8120,
    releaseDate: '2023-03-28',
  },
  {
    id: 2009,
    title: '甜心料理屋',
    enTitle: 'Sweet Kitchen',
    year: 2024,
    rating: 8.0,
    genres: ['美食', '治愈'],
    region: '日本',
    director: '佐藤绫',
    cast: ['新垣美咲', '高桥凉介', '小林夏帆'],
    episodes: 28,
    status: '连载中',
    poster: 'https://readdy.ai/api/search-image?query=A%20cozy%20small%20restaurant%20counter%20with%20warm%20orange%20lights%20and%20steaming%20dishes%2C%20healing%20food%20drama%20poster%2C%20deep%20navy%20evening%20tones%2C%20soft%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20cozy%20night%20food%20street%20with%20warm%20orange%20lanterns%20and%20deep%20navy%20sky%2C%20healing%20drama%20wide%20shot%2C%20soft%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-09&orientation=landscape',
    synopsis: '一间只在深夜营业的小小料理屋，店里只有八个座位。每位推门进来的客人都带着自己的烦恼，而老板娘总能端出一道恰好治愈他们的菜。吃下这口热乎的，明天好像就没那么难了。',
    type: 'tv',
    popularity: 6640,
    releaseDate: '2024-09-13',
  },
  {
    id: 2010,
    title: '帝国往事',
    enTitle: 'Empire Chronicles',
    year: 2022,
    rating: 8.9,
    genres: ['历史', '剧情'],
    region: '英国',
    director: 'Oliver Grant',
    cast: ['亨利·布莱克', '伊芙琳·凯奇', '亚瑟·摩尔'],
    episodes: 42,
    status: '已完结',
    poster: 'https://readdy.ai/api/search-image?query=A%20regal%20crowned%20figure%20standing%20in%20a%20candlelit%20throne%20hall%2C%20epic%20historical%20drama%20poster%2C%20deep%20navy%20shadow%20with%20warm%20amber%20candle%20glow%2C%20dramatic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=tv-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20grand%20candlelit%20throne%20hall%20with%20warm%20amber%20glow%20and%20deep%20navy%20shadows%2C%20epic%20historical%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=tv-backdrop-10&orientation=landscape',
    synopsis: '从一场宫廷政变开始，讲述一个庞大帝国由盛转衰的百年兴亡。野心、忠诚、背叛与牺牲交织在王座之下，而那些被史书一笔带过的人，才是真正推动时代向前的手。',
    type: 'tv',
    popularity: 7420,
    releaseDate: '2022-02-25',
  },
];